// extracted by mini-css-extract-plugin
export default {"filters":"TableFilter_filters__jPZjH","tablet_filters":"TableFilter_tablet_filters__inJ3q"};